// tslint:disable
/**
 * Ux
 * insightux admin api
 *
 * The version of the OpenAPI document: 0.62
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { EntityTypeFromJSON, EntityTypeToJSON, } from './';
export function PmiAssociationFromJSON(json) {
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'entityId': json['entityId'],
        'entityType': EntityTypeFromJSON(json['entityType']),
        'pmis': !exists(json, 'pmis') ? undefined : json['pmis'],
    };
}
export function PmiAssociationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'id': value.id,
        'entityId': value.entityId,
        'entityType': EntityTypeToJSON(value.entityType),
        'pmis': value.pmis,
    };
}
